// import React from 'react';
// import { useMsal } from '@azure/msal-react';

// function Login({ onLogin }) {
//   const { instance } = useMsal();

//   const login = async () => {
//     try {
//       const loginRequest = {
//         scopes: ["User.Read"]
//       };
//       await instance.loginRedirect(loginRequest);
//     } catch (error) {
//       console.error('Login failed:', error);
//     }
//   };

//   return (
//     <div>
//       <h1>Please login</h1>
//       <button onClick={login}>Login with Microsoft</button>
//     </div>
//   );
// }

// export default Login;

// src/Login.js
import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import axios from "axios";
import { Navigate } from "react-router-dom";
import api from "./axiosConfig";

function Login({ onUserValidated }) {
  const { instance, accounts } = useMsal();
  //const [userValidated, setUserValidated] = useState(false);
  const [redirectToSummary, setRedirectToSummary] = useState(false);

  useEffect(() => {
    if (accounts.length > 0) {
      const email = accounts[0].username;
      api
        .post("/validate-user", { email }) // Backend endpoint to validate email
        .then((response) => {
          if (response.data.success) {
            localStorage.setItem("user", accounts[0].username);
            localStorage.setItem("username", accounts[0].name);
            localStorage.setItem("isAdmin", response?.data?.user?.admin_access);
            // setUserValidated(true);
            onUserValidated(); // Update App.js validation status
            setRedirectToSummary(true);
          }
        })
        .catch((error) => console.error("Validation failed", error));
    }
  }, [accounts, onUserValidated]);

  const handleLogin = () => {
    instance
      .loginPopup({
        scopes: ["User.Read"],
      })
      .catch((error) => console.error("Login failed", error));
  };

  if (redirectToSummary) {
    return <Navigate to="/current-month-summary" replace />;
  }
  //<button onClick={handleLogin}>Login with Microsoft</button>;
  return (
    <div style={styles.container}>
      <div style={styles.loginBox}>
        <img
          src="https://www.idfreshfood.com/wp-content/uploads/2019/07/new-logo-120-1.png"
          alt="Company Logo"
          style={styles.logo}
        />
        <h2 style={styles.title}>MonthPlanner</h2>
        <button onClick={handleLogin} style={styles.loginButton}>
          Login with Microsoft
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#149485",
  },
  loginBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "100px",
    boxShadow: "0 4px 16px rgba(0, 0, 0, 0.2)",
    borderRadius: "8px",
    backgroundColor: "#FFFFFF",
  },
  logo: {
    width: "100px",
    marginBottom: "20px",
  },
  title: {
    fontSize: "24px",
    color: "#333",
    marginBottom: "20px",
  },
  loginButton: {
    padding: "12px 24px",
    fontSize: "24px",
    color: "#FFFFFF",
    backgroundColor: "#149485",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  },
};

export default Login;
